import { Check, ArrowRight } from "lucide-react";

const packages = [
  {
    id: "corporate",
    tag: "Programme I",
    name: "Corporate Travel Management",
    price: "From ₹1,999 / booking",
    description:
      "For finance and operations teams that need auditable, policy-compliant travel across a distributed workforce.",
    features: [
      "Named advisor + dedicated concierge line",
      "Travel policy design & enforcement",
      "Live expense reporting & GST reconciliation",
      "Duty of care & traveller tracking",
      "Consolidated monthly invoicing",
      "Quarterly savings review",
    ],
    accent: false,
  },
  {
    id: "executive",
    tag: "Programme II",
    name: "Executive Premium",
    price: "By private consultation",
    description:
      "For C-suite executives, founders and family offices. White-glove aviation, hotels, and ground.",
    features: [
      "Private jet & fractional aviation access",
      "First class & suite-only hotel bookings",
      "VIP airport meet-and-assist worldwide",
      "Encrypted itineraries, discreet handling",
      "Chief-of-staff trip management",
      "24/7 principal support in 4 languages",
    ],
    accent: true,
  },
];

export default function Packages() {
  return (
    <section
      id="packages"
      data-testid="packages-section"
      className="relative py-24 sm:py-32 bg-[#FFF8F1] border-t border-[#4A1D96]/10"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mb-14 reveal">
          <span className="uppercase tracking-[0.28em] text-xs text-[#F97316] font-semibold">
            Corporate Programmes
          </span>
          <h2
            data-testid="packages-heading"
            className="mt-4 font-serif text-4xl sm:text-5xl leading-[1.05] text-[#1B0F3A]"
          >
            Two programmes.
            <br />
            <span className="brand-gradient italic font-medium">
              Both engineered
            </span>{" "}
            around your calendar.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
          {packages.map((p) => (
            <div
              key={p.id}
              data-testid={`package-${p.id}`}
              className={`relative reveal p-8 sm:p-10 border-2 bg-white transition-all duration-500 hover:-translate-y-1 ${
                p.accent
                  ? "border-[#F97316] shadow-[0_25px_60px_-30px_rgba(249,115,22,0.5)]"
                  : "border-[#4A1D96]/15 hover:border-[#4A1D96]"
              }`}
            >
              {p.accent && (
                <div className="absolute -top-3 left-8 bg-[#F97316] text-white text-[10px] uppercase tracking-[0.28em] font-bold px-3 py-1.5">
                  Signature
                </div>
              )}
              <div className="text-xs uppercase tracking-[0.28em] text-[#F97316] font-semibold">
                {p.tag}
              </div>
              <h3 className="mt-4 font-serif text-3xl sm:text-4xl text-[#1B0F3A]">
                {p.name}
              </h3>
              <div className="mt-3 text-[#4A1D96] text-sm uppercase tracking-[0.18em] font-semibold">
                {p.price}
              </div>
              <p className="mt-6 text-[#3B2A5B] leading-relaxed">
                {p.description}
              </p>

              <ul className="mt-8 space-y-4">
                {p.features.map((f) => (
                  <li key={f} className="flex items-start gap-3 text-[#1B0F3A]">
                    <div
                      className={`mt-0.5 flex-shrink-0 w-5 h-5 flex items-center justify-center ${
                        p.accent ? "bg-[#F97316]" : "bg-[#4A1D96]"
                      }`}
                    >
                      <Check size={12} className="text-white" strokeWidth={3} />
                    </div>
                    <span className="text-[0.95rem]">{f}</span>
                  </li>
                ))}
              </ul>

              <a
                href="#contact"
                data-testid={`package-cta-${p.id}`}
                className={`mt-10 inline-flex items-center gap-3 px-6 py-3.5 text-sm uppercase tracking-[0.2em] font-semibold transition-colors ${
                  p.accent
                    ? "bg-[#F97316] text-white hover:bg-[#4A1D96]"
                    : "border-2 border-[#4A1D96] text-[#4A1D96] hover:bg-[#4A1D96] hover:text-white"
                }`}
              >
                Request Programme <ArrowRight size={16} />
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
